export const REWARD_XP_CLASS =
  'font-heading text-xs font-bold tabular-nums text-[hsl(142,71%,52%)]';
export const REWARD_GOLD_CLASS =
  'font-heading text-xs font-bold tabular-nums text-[hsl(43,82%,58%)]';
